import React, { Component } from 'react';
import { Button, Modal, List } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

class DeleteLeaveProfileModal extends Component {
    state = {
        busy: false
    }

    handleClose = () => {
        this.props.onClose();
    }

    handleDelete = () => {
        this.setState({ busy: true });
        this.props.onDelete();
    }

    handleRemoveTaggingAndDelete = () => {
        this.setState({ busy: true });
        this.props.onRemoveTaggingAndDelete();
    }

    render() {
        const { usageData } = this.props;
        const isUsed = usageData && usageData.isUsed;
        const employees = usageData && usageData.employees ? usageData.employees : [];

        return (
            <Modal open size='small'>
                <Modal.Header>DELETE LEAVE PROFILE</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        {isUsed ? (
                            <>
                                <p>
                                    Can't Proceed in Deleting the Leave Profile, it is tagged to the employees below.
                                    To proceed with the deletion, please remove the tagging from the employees.
                                </p>
                                <p><strong>List of Employees that are tagged to the profile:</strong></p>
                                <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px', borderRadius: '4px' }}>
                                    <List bulleted>
                                        {employees.map((emp, index) => (
                                            <List.Item key={index}>{emp.FullName}</List.Item>
                                        ))}
                                    </List>
                                </div>
                            </>
                        ) : (
                            <p>Are you sure you want to delete this Leave Profile?</p>
                        )}
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    {isUsed ? (
                        <>
                            <Button
                                color='red'
                                disabled={this.state.busy}
                                loading={this.state.busy}
                                onClick={this.handleRemoveTaggingAndDelete}
                            >
                                Remove Tagging and Delete
                            </Button>
                            <Button
                                basic
                                disabled={this.state.busy}
                                onClick={this.handleClose}
                            >
                                Cancel
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button
                                basic
                                icon='check'
                                content='Yes'
                                disabled={this.state.busy}
                                loading={this.state.busy}
                                onClick={this.handleDelete}
                            />
                            <Button
                                basic
                                icon='cancel'
                                content='No'
                                disabled={this.state.busy}
                                onClick={this.handleClose}
                            />
                        </>
                    )}
                </Modal.Actions>
            </Modal>
        );
    }
}

export default DeleteLeaveProfileModal;
